import Vue from 'vue';
import {formatDate} from './common.js';
// 超出62 字显示省略号
Vue.filter('ellipsis', (value) => {
	if (!value) return '';
	if (value.length > 12) {
		return value.slice(0,12) + '...';
	}
	return value;
});
Vue.filter('formatBytes',(bytes, decimals = 2)=> {
	if (bytes === 0) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
});

Vue.filter('drawNumber', (name) => {
	if(name!=null){
		let value = name.toString();
		if (!value) return '';
		if (value.length === 1) {
			return '00'+value;
		}else if (value.length === 2) {
			return '0'+value;
		}
		return value;
	}
});
Vue.filter('timestampToTime',  (value)=> {
	if(!value) return '';
	let date = new Date(parseInt(value));
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM;
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m;
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s;
	return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
});
Vue.filter('tomorrowTime',(value)=>{
	let date = new Date(parseInt(value));
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM;
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	if (date.getHours() >= 6 && date.getHours() < 12) {
		return false
	} else if (date.getHours() >= 12 && date.getHours() < 24) {
		return y + '-' + MM + '-' + (d+1)
	} else {
		return false
	}
});


// 时间戳转换年月日格式' yyyy/MM/dd'
Vue.filter('formatDate', (time) => {
	if(!time) return '';
	time = time * 1000;
	let date = new Date(time);
	return formatDate(date, 'yyyy/MM/dd');
});
// 时间戳转换年月日格式' yyyy/MM/dd hh:mm'
Vue.filter('formatDates', (time) => {
	if(!time) return '';
	time = time * 1000;
	let date = new Date(time);
	return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
});
// 时间戳转换年月日格式' yyyy-MM-dd'
Vue.filter('formatDatetime', (time) => {
	if(!time) return '';
	time = time * 1000;
	let date = new Date(time);
	return formatDate(date, 'yyyy-MM-dd');
});
// yyyy-MM-dd hh:mm:ss  转为 yyyy-MM-dd
Vue.filter('formatDatetimeSub', (time) => {
	return time.substring(0,10);
});
// 手机号中间四位*代替

Vue.filter('phoneHideString', function(value) {
	let str = String(value);
	let strLen = str.slice(-7,-3);
	return str.replace(strLen,"****");
});
//隐藏姓名
Vue.filter('nameHide', function(value) {
	value = value && value.trim();
	if(!value) return '--';
	let newStr;
	if(value.length === 2) {
		newStr = value.substr(0, 1) + '*';
	} else if(value.length > 2) {
		let char = '';
		for(let i = 0, len = value.length - 1; i < len; i++) {
			char += '*';
		}
		newStr = value.substr(0, 1) + char;
	} else {
		newStr = value;
	}
	return newStr;
});
/**
 * 将数字脱敏
 * @params num
 * 手机号码
 */
// 手机号码中间4位数打码显示'188****8888'
Vue.filter('phoneHideValue', (value) => {
	if(!value) return '';
	let str = String(value);
	let reg = /^(\d{3})\d{4}(\d{4})$/;
	return str.replace(reg, "$1****$2");
});
/**
 * 将数字脱敏
 * @params num
 * 身份证号
 */
// 身份证号中间打码显示'110******2290'
Vue.filter('idCardHideValue', (value) => {
	if(!value) return '';
	let str = String(value);
	let reg = /^(.{4})\d+(.{4})$/;
	return str.replace(reg, "$1******$2");
});



// Vue.filter('phoneHide', function(value) {
// 	if(!value) return '--'
// 	value = value.toString()
// 	let reg = /^(\d{3})\d{4}(\d{4})$/
// 	return value.replace(reg, '$1****$2')
// });
// 姓名的名字打码显示'赵**'（不兼容ios和Safari浏览器）
// Vue.filter('nameHideValue', (value) => {
// 	if(!value) return '';
// 	var reg = /(?<=.)./g;
//     return value.replace(reg, '*');
// });


Vue.filter('formatNumberData', function(value) {
	if (isNaN(value)) return value;

	const num = Number(value);

	if (num >= 100000000) {
		return (num / 100000000).toFixed(1) + '亿';
	}
	if (num >= 10000) {
		return (num / 10000).toFixed(1) + '万';
	}
	if (num >= 1000) {
		return (num / 1000).toFixed(1) + '千';
	}

	return num.toString();
});
function formatNumber(value, options = {}) {
	if (isNaN(value)) return value;

	const num = Number(value);
	const {
		decimal = 1,
		units = [
			{ threshold: 100000000, suffix: '亿' },
			{ threshold: 10000, suffix: '万' },
			{ threshold: 1000, suffix: '千' }
		]
	} = options;

	for (const unit of units) {
		if (num >= unit.threshold) {
			return (num / unit.threshold).toFixed(decimal) + unit.suffix;
		}
	}

	return num.toString();
}

// 在Vue中使用
Vue.filter('smartNumber', formatNumber);